import { create } from 'zustand';

export const useIsOpenedStore = create(set => ({
  isOpened: false,
  toggleIsOpened: () => set(state => ({ isOpened: !state.isOpened })),
  closeNotificationList: () => set(() => ({ isOpened: false }))
}));

export const useUnreadCountStore = create(set => ({
  unreadCount: 0,
  setUnreadCount: unreadCount => set(() => ({ unreadCount })),
  incrementUnreadCount: () => set(state => ({ unreadCount: state.unreadCount + 1 })),
  decrementUnreadCount: () => set(state => ({ unreadCount: state.unreadCount - 1 }))
}));
